// extracted by mini-css-extract-plugin
module.exports = {"selectedUser":"selectOrder_selectedUser__3bKWI","selectedUserName":"selectOrder_selectedUserName__W_4qT","avatar":"selectOrder_avatar__2-FDD"};